import * as io from 'io-ts';
import { boolean } from '@shared/core/types/common';

const rootDefinition: io.MixedObject<OLO.Config.VirtualLocations> = {
    enabled: boolean,
};

export const virtualLocationsSchema = io.type(rootDefinition);
